import i18next from 'i18next';
import {ofType} from 'redux-observable';
import {of} from 'rxjs';
import {flatMap, catchError} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import {showDeleteDialogObservable, DialogChoice} from 'web-app/react/dialog';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Api from './api';
import * as Actions from './actions';

const fetch = action$ =>
    action$.pipe(
        ofType(Actions.fetch.type),
        flatMap(({payload}: ReturnType<typeof Actions.fetch.action>) => {
            return Api.fetch(payload.institutionId, true).pipe(
                flatMap(response => {
                    return of(Actions.fetchSuccess.action(response));
                }),
                catchError(error => {
                    return of(Actions.fetchFailed.action(error));
                }),
            );
        }),
    );

const fetchSingle = action$ =>
    action$.pipe(
        ofType(Actions.fetchSingle.type),
        flatMap(({payload}: ReturnType<typeof Actions.fetchSingle.action>) => {
            return Api.fetchSingle(payload.vacationId).pipe(
                flatMap(response => {
                    return of(Actions.fetchSingleSuccess.action(response));
                }),
                catchError(error => {
                    return of(Actions.fetchSingleFailed.action(error));
                }),
            );
        }),
    );

const deleteVacationPlan = action$ =>
    action$.pipe(
        ofType(Actions.deleteVacationPlan.type),
        flatMap(({payload}: ReturnType<typeof Actions.deleteVacationPlan.action>) => {
            return showDeleteDialogObservable({
                title: '',
                description: i18next.t('calendar.vacationPeriod.confirmDeleteVacation'),
            }).pipe(
                flatMap(selection => {
                    if (selection === DialogChoice.OK) {
                        return Api.deleteVacationPlan(payload.vacationId).pipe(
                            flatMap(response => {
                                return [
                                    Actions.deleteVacationPlanSuccess.action(response),
                                    GlobalEventActions.updateSuccess.action(
                                        i18next.t('calendar.vacationPeriod.vacationPeriodDeleted'),
                                    ),
                                ];
                            }),
                            catchError(error => {
                                return of(Actions.deleteVacationPlanFailed.action(error));
                            }),
                        );
                    } else {
                        return of(Actions.deleteVacationPlanAborted.action());
                    }
                }),
            );
        }),
    );

export default combineEpics(fetch, fetchSingle, deleteVacationPlan);
